// removed by extract-text-webpack-plugin
module.exports = {"sector-icons":"sector-icons___2hbLj","sector-icons__col":"sector-icons__col___1mse_ h3___5u0xZ center___2iqBf","sector-icons__img":"sector-icons__img___SIghK"};